module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "dark-top",
    attrs: {
      "dialog": "modal-lg",
      "footer": false,
      "headerStyle": {
        'background-color': _vm.currentIntegration.color.main
      }
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h2', [_vm._v("Primavera")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('top-area', {
    attrs: {
      "integration": _vm.currentIntegration
    }
  }), _vm._v(" "), _c('steps', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    },
    on: {
      "switchStep": _vm.switchStep
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "px-5 pt-4 pb-4"
  }, [(_vm.getIsPrimaveraSettingsLoading || (_vm.isLoading && _vm.currentStep !== 1)) ? _c('div', {
    staticClass: "text-center w-100 p-3 d-flex justify-content-center align-items-center",
    staticStyle: {
      "min-height": "328px"
    }
  }, [_c('loader')], 1) : _vm._e(), _vm._v(" "), (!_vm.getIsPrimaveraSettingsLoading && _vm.currentStep === 1) ? _c('div', {
    staticClass: "min-section-height d-flex flex-column justify-content-center"
  }, [_c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('label', {
    staticClass: "col-md-12 p-0"
  }, [_vm._v("API Endpoint"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.defaultUrl),
      expression: "primaveraData.defaultUrl"
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.primaveraData.defaultUrl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "defaultUrl", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.primaveraData.defaultUrl.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.defaultUrl.required) ? _c('span', [_vm._v("API Endpoint is required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('label', {
    staticClass: "col-md-12 p-0"
  }, [_vm._v("Line"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('v-select', {
    key: _vm.primaveraData.primaveraLine,
    staticClass: "black-text primavera-select",
    attrs: {
      "options": _vm.lineOptions,
      "value": _vm.getLineValue(_vm.primaveraData.primaveraLine),
      "placeholder": "Select line",
      "disabled": _vm.lineOptions.length === 0
    },
    on: {
      "input": function($event) {
        return _vm.lineInput($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.$v.primaveraData.primaveraLine.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.primaveraLine.required) ? _c('span', [_vm._v("Line is required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('label', {
    staticClass: "col-md-12 p-0"
  }, [_vm._v("Create Sales Document Endpoint\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.createSalesDocumentEndpoint),
      expression: "primaveraData.createSalesDocumentEndpoint"
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.primaveraData.createSalesDocumentEndpoint)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "createSalesDocumentEndpoint", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('label', {
    staticClass: "col-md-12 p-0"
  }, [_vm._v("Company Name"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.company),
      expression: "primaveraData.company"
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.primaveraData.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "company", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.primaveraData.company.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.company.required) ? _c('span', [_vm._v("Company Name is required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0 pr-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Username"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.username),
      expression: "primaveraData.username"
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.primaveraData.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "username", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.primaveraData.username.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.username.required) ? _c('span', [_vm._v("Username is required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Password"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.password),
      expression: "primaveraData.password"
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.primaveraData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "password", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.primaveraData.password.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.password.required) ? _c('span', [_vm._v("Password is required.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('label', {
    staticClass: "col-md-12 p-0"
  }, [_vm._v("Article List ID"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.defaultArticleListID),
      expression: "primaveraData.defaultArticleListID"
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.primaveraData.defaultArticleListID)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "defaultArticleListID", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.$v.primaveraData.defaultArticleListID.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.defaultArticleListID.required) ? _c('span', [_vm._v("Article List ID is required")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.getIsPrimaveraSettingsLoading && _vm.currentStep === 2 && !_vm.isLoading) ? _c('div', {
    staticClass: "min-section-height d-flex flex-column justify-content-center"
  }, [_c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0 pr-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Series"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('v-select', {
    key: _vm.primaveraData.defaultSerie,
    staticClass: "black-text primavera-select",
    attrs: {
      "label": "description",
      "value": _vm.getSeriesValue(_vm.primaveraData.defaultSerie),
      "options": _vm.getPrimaveraSeries,
      "placeholder": "Select series",
      "disabled": _vm.getIsResquestingPrimaveraSeriesLoading || _vm.getPrimaveraSeries.length === 0
    },
    on: {
      "input": function($event) {
        return _vm.seriesInput($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.$v.primaveraData.defaultSerie.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.defaultSerie.required) ? _c('span', [_vm._v("Series is required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Series Map"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('input', {
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.primaveraData.defaultSerieConfiguration
    }
  })]), _vm._v(" "), (_vm.$v.primaveraData.defaultSerieConfiguration.$invalid) ? _c('div', {
    staticClass: "messages error"
  }, [(!_vm.$v.primaveraData.defaultSerieConfiguration.required) ? _c('span', [_vm._v("Series Map is required")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 d-flex flex-column min-payment-height"
  }, [_c('div', {
    staticClass: "d-flex payment-labels"
  }, [_c('label', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0"
  }, [_vm._v("Payment Terms"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")])]), _vm._v(" "), _c('label', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0"
  }, [_vm._v("Payment Conditions"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")])])]), _vm._v(" "), _vm._l((_vm.getDocumentTypes), function(type, index) {
    return _c('div', {
      staticClass: "d-flex mb-1 p-0",
      class: {
        'border-bottom-light pb-1': index + 1 !== _vm.getDocumentTypes.length
      }
    }, [_c('div', {
      staticClass: "col-6 col-sm-6 col-md-6 d-flex justify-content-end align-items-center payment-height"
    }, [_c('span', {
      staticClass: "fs-normal bold"
    }, [_vm._v("\n                                " + _vm._s(((type.id) + ": " + (type.label))) + "\n                            ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-sm-6 col-md-6 p-0"
    }, [_c('v-select', {
      ref: index,
      refInFor: true,
      staticClass: "smaller-select",
      attrs: {
        "label": "label",
        "value": _vm.getPaymentConditionsValue(type),
        "placeholder": "Select condition",
        "options": _vm.getPaymentConditions,
        "disabled": _vm.getIsResquestingPrimaveraSeriesLoading
      },
      on: {
        "input": function($event) {
          return _vm.paymentConditionsInput($event, type)
        }
      }
    })], 1)])
  }), _vm._v(" "), (_vm.$v.primaveraData.paymentConditions.$invalid) ? _c('div', {
    staticClass: "row error payment-height"
  }, [_c('span', {
    staticClass: "col-6 col-sm-6 col-md-6"
  }), _vm._v(" "), (!_vm.$v.primaveraData.paymentConditions.required) ? _c('span', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0"
  }, [_vm._v("Payment Conditions are required")]) : _vm._e()]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('label', {
    staticClass: "full col-md-12 p-0"
  }, [_vm._v("Default Reasons for Credit Notes on Canceled Reservation"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")]), _vm._v(" "), _c('v-select', {
    key: _vm.primaveraData.defaultChargebackReason,
    staticClass: "col-md-12 p-0 black-text primavera-select",
    attrs: {
      "value": _vm.getChargeBackReasonValue(_vm.primaveraData.defaultChargebackReason),
      "options": _vm.getChargeBackReason,
      "disabled": _vm.getIsChargeBackReasonsLoading || _vm.getChargeBackReason.length === 0,
      "label": "label",
      "placeholder": "Select reason"
    },
    on: {
      "input": function($event) {
        return _vm.chargeBackReasonInput($event)
      }
    }
  })], 1), _vm._v(" "), (_vm.$v.primaveraData.defaultChargebackReason.$invalid) ? _c('div', {
    staticClass: "col-md-12 p-0 error"
  }, [(!_vm.$v.primaveraData.defaultChargebackReason.required) ? _c('span', [_vm._v("Default Reasons is required")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.getIsPrimaveraSettingsLoading && _vm.currentStep === 3 && !_vm.isLoading) ? _c('div', {
    staticClass: "min-section-height d-flex flex-column justify-content-center"
  }, [_c('div', {
    staticClass: "row mb-2 col-md-12 p-0"
  }, [_c('div', {
    staticClass: "bold fs-large"
  }, [_vm._v("\n                        End Customer Data Configuration \n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-small dark"
  }, [_vm._v("\n                        (These details will be automatically applied to direct bookings without other customer information provided).\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height"
  }, [_c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0 pr-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Name"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.defaultEndCustomerName),
      expression: "primaveraData.defaultEndCustomerName"
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.primaveraData.defaultEndCustomerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "defaultEndCustomerName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$v.primaveraData.defaultEndCustomerName.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.defaultEndCustomerName.required) ? _c('span', [_vm._v("Name is required")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("VAT Number"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.primaveraData.defaultEndCustomerTaxNumber),
      expression: "primaveraData.defaultEndCustomerTaxNumber",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "bg-lighter w-100",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.primaveraData.defaultEndCustomerTaxNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "defaultEndCustomerTaxNumber", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.$v.primaveraData.defaultEndCustomerTaxNumber.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.defaultEndCustomerTaxNumber.required) ? _c('span', [_vm._v("Company Name is required")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex payment-labels"
  }, [_c('label', {
    staticClass: "col-md-6 p-0"
  }, [_vm._v("Payment Types"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-6 p-0"
  }, [_vm._v("Primavera Payment type"), _c('span', {
    staticClass: "brand"
  }, [_vm._v(" * ")])])]), _vm._v(" "), _c('div', {
    ref: "parentContainer",
    staticClass: "payment-types"
  }, _vm._l((_vm.getPaymentTypes), function(type, index) {
    return _c('div', {
      staticClass: "d-flex mb-1 p-0",
      class: {
        'border-bottom-light pb-1': index + 1 !== _vm.getPaymentTypes.length
      }
    }, [_c('div', {
      staticClass: "col-6 col-sm-6 col-md-6 d-flex justify-content-end align-items-center payment-height"
    }, [_c('span', {
      staticClass: "fs-small bold"
    }, [_vm._v("\n                                    " + _vm._s(type.label) + "\n                                ")])]), _vm._v(" "), _c('div', {
      staticClass: "col-6 col-sm-6 col-md-6 pl-2"
    }, [_c('v-select', {
      ref: 'select-' + index,
      refInFor: true,
      staticClass: "smaller-select",
      class: {
        'open-up': _vm.isOpenUp[index]
      },
      attrs: {
        "label": "label",
        "value": _vm.getErpPaymentTypesValue(type),
        "placeholder": "Select condition",
        "options": _vm.getErpPaymentTypes,
        "disabled": _vm.getIsResquestingErpPaymentTypeLoading
      },
      on: {
        "input": function($event) {
          return _vm.erpPaymentTypesInput($event, type)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.toggleDirection(index)
        }
      }
    })], 1)])
  }), 0), _vm._v(" "), (_vm.$v.primaveraData.paymentTypes.$invalid) ? _c('div', {
    staticClass: "row error payment-height"
  }, [_c('span', {
    staticClass: "col-6 col-sm-6 col-md-6"
  }), _vm._v(" "), (!_vm.$v.primaveraData.paymentTypes.required) ? _c('span', {
    staticClass: "col-6 col-sm-6 col-md-6 p-0"
  }, [_vm._v("Primavera Payment type is required")]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.getIsPrimaveraSettingsLoading && _vm.currentStep === 4 && !_vm.isLoading) ? _c('div', {
    staticClass: "min-section-height"
  }, [_c('div', {
    staticClass: "row mb-2 col-md-12 p-0"
  }, [_c('div', {
    staticClass: "bold fs-large"
  }, [_vm._v("\n                        Customer Identifier Configuration\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-normal darker mt-3"
  }, [_vm._v("\n                        Define a prefix for customer identifiers. The final code will have a maximum of 12 characters.\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 row-height mt-3"
  }, [_c('div', {
    staticClass: "col-12 col-sm-12 col-md-12 p-0 pr-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("Customer Identifier Prefix (optional, max. 3 characters)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaveraData.codePrefix),
      expression: "primaveraData.codePrefix"
    }],
    staticClass: "bg-lighter w-100 mt-1",
    attrs: {
      "type": "text",
      "placeholder": "PL"
    },
    domProps: {
      "value": (_vm.primaveraData.codePrefix)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.primaveraData, "codePrefix", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$v.primaveraData.codePrefix.$invalid) ? _c('div', {
    staticClass: "error"
  }, [(!_vm.$v.primaveraData.codePrefix.maxLength) ? _c('span', [_vm._v("Maximum length of 3 characters.")]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2 col-md-12 p-0 mt-3"
  }, [_c('div', {
    staticClass: "fs-small color-1"
  }, [_vm._v("\n                        If you define a prefix, the customer identifier will be adjusted to maintain the 12-character limit in total.\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "fs-small color-1"
  }, [_vm._v("\n                        If no prefix is provided, the code will use the last 12 digits of the VAT number.\n                    ")])])]) : _vm._e(), _vm._v(" "), _c('bottom-area', {
    attrs: {
      "isIntegrated": true,
      "isInvoicing": true,
      "showNextBtn": _vm.showNextBtn,
      "disableNextBtn": _vm.disableNextBtn,
      "showPrevBtn": _vm.showPrevBtn,
      "showConnectionBtn": _vm.showConnectionBtnVal,
      "disableConnectionBtn": _vm.disableConnectionBtnVal,
      "showSaveBtn": _vm.showSaveBtnVal,
      "disableSaveBtn": _vm.disableSaveBtnVal,
      "loadingSaveBtn": _vm.loadingSaveBtnVal
    },
    on: {
      "disableIntegration": function($event) {
        return _vm.clickDeactivate()
      },
      "saveIntegration": function($event) {
        return _vm.savePrimaveraData()
      },
      "nextStep": function($event) {
        return _vm.nextStep()
      },
      "prevStep": function($event) {
        return _vm.prevStep()
      },
      "testConnection": function($event) {
        return _vm.testConnection()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-33975f52", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33975f52"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/integrations/integratePopup/primaveraIntegrate.vue
// module id = 3211
// module chunks = 0